import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  container: {
    float: isMobile ? 'none' : 'right',
    width: isMobile ? '100vw' : '80vw',
    height: '100vh',
    background: '#fff'
  },
  iframe: {
    width: '100%',
    height: '100vh'
  }
});

class PrintStore extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.container}>
        <iframe className={classes.iframe} src={this.props.url} referrerpolicy={'origin-when-cross-origin'} />
      </div>
    );
  }
}

export default withStyles(styles, {withTheme: true})(PrintStore);
